import { DataService, ApiService } from "../service"
import {Category} from "@/libs";

export class RespurceService{
  // 获取资源列表
  static async search(page: number = 1, pageSize: number = 20, dirCategoryId: number, dirId: number, orderBy: string, keyword?: string, exts?: string[]) {
    const categoryId = this.getDataCategoryId(dirCategoryId);
    const params: any = {
      dirCategoryId,
      dirId,
      orderBy,
      categoryId
    };
    if (keyword) {
      params.q = keyword;
    }
    if (exts && exts.length) {
      params.exts = exts;
      delete params.dirId;
    }
    return DataService.post(`${ApiService.JrzzApi}/res/search?page=${page}&pageSize=${pageSize}`, params);
  }

  // 获取外协资源列表
  static async outSearch(page: number = 1, pageSize: number = 20, dirCategoryId: number, dirId: number, dataCategoryId: number, orderBy: string, keyword?: string, exts?: string[]) {
    const params: any = {
      dirCategoryId,
      dirId,
      orderBy,
      dataCategoryId
    };
    if (keyword) {
      params.q = keyword;
    }
    if (exts && exts.length) {
      params.exts = exts;
      delete params.dirId;
    }
    return DataService.get(`${ApiService.ProfitApi}/res/search?page=${page}&pageSize=${pageSize}`, params);
  }
  

  static getDataCategoryId(dirCategoryId: number) {
    if (dirCategoryId == Category.OutSourceDir||dirCategoryId == Category.OutSourceDirShare) {
      return Category.OutSource
    } else if (dirCategoryId == Category.EnterpriseDir||dirCategoryId == Category.EnterpriseShare) {
      return Category.Enterprise
    }
  }

  /**
   * 修改资源
   * @param resId 
   * @param CompID 
   * @param Remark 
   * @returns 
   */
  static async update(resId: string, CompID: number, Remark: string) {
    return await DataService.post(`${ApiService.JrzzApi}/res/update?resId=${resId}`, {
      CompID,
      Remark,
      IsShare: 0,
    })
  }
  
  /**
   * 根据目录id等相关信息，查询资源列表
   * @param dirCategoryId 
   * @param categoryId 
   * @param dirId 
   * @param page 
   * @param pageSize 
   * @returns 
   */
  static async getResListByCategoryId(dirCategoryId: number, categoryId: number, dirId: number, page = 1, pageSize = 15, isPower = false) {
    let key = 'data';
    isPower && (key = 'power/data')
    return await DataService.get(`${ApiService.JrzzApi80}/${key}/${dirCategoryId}/${categoryId}/list?dirId=${dirId}&page=${page}&pageSize=${pageSize}`)
  }
  
}